import Input from "../../../Medicine-master/Component/Input";

export const MyLabInput = [
  {
    tag: Input,
    img: "",
    label: "Lab Name",
    name: "labName",
    validation: "required",
    required: true,
    key: "labName",
  },
  {
    tag: Input,
    img: "",
    label: "Email",
    name: "email",
    validation: "required",
    required: true,
    key: "email",
  },
  {
    tag: Input,
    img: "",
    label: "Password",
    name: "password",
    validation: "required",
    required: true,
    key: "password",
  },
  {
    tag: Input,
    img: "",
    label: "Phone Number",
    name: "phone",
    validation: "required",
    required: true,
    key: "phone",
  },
  {
    tag: Input,
    img: "",
    label: "Branch Name",
    name: "branchName",
    required: true,
    key: "branchName",
    role:"super_admin"
  },
];
